import React from 'react';
import { Navigate } from 'react-router-dom';

const RouteGuard = ({ children }) => {

    function hasJWT() {
        //check user has JWT token
        return sessionStorage.getItem("Token") ? true : false
    }

    return (
        <>
            {hasJWT() ?
                children
                :
                <Navigate to='/' />
                //children
            }
        </>
    );
};

export default RouteGuard;